const BASE_URL='https://api.nextm2m.ro:4455'
// const BASE_URL='http://localhost:3400'
export {BASE_URL}
